import { type NotificaResponseDTO } from '@framework/api-client/api/backoffice/schemas/notificaResponseDTO.ts';
import { List } from 'antd';
import { NotificationListItem } from './detail/NotificationListItem.tsx';

interface NotificationListProps {
  list: NotificaResponseDTO[] | null | undefined;
  loading: boolean;
}

/**
 * Elenco delle notifiche
 */
export function NotificationList(props: NotificationListProps) {
  const { list, loading } = props;
  if (!list) return null;

  return (
    <List
      loading={loading}
      size="small"
      itemLayout="horizontal"
      dataSource={props.list ?? undefined}
      renderItem={item => {
        return <NotificationListItem notification={item} />;
      }}
    />
  );
}
